import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class ClubProgramService {

  private api = '/api/ClubProgram';

  constructor(
    private bs: HttpService
  ) { }

  getClubPrograms(clubID: number, userID: number) {
    return this.bs.get(`${this.api}/club-programs-by-userid/${clubID}/${userID}`);
  }

  getClubByID(clubID: number) {
    return this.bs.get(`${this.api}/club/${clubID}`);
  }

  getUserCredit(clubProgramID: number, userID: number) {
    return this.bs.get(`${this.api}/get-user-credit/${clubProgramID}/${userID}`);
  }

  /*------- Donation / Sponsorship  -------*/
  getDonationSponsorshipData(clubProgramID: number) {
    return this.bs.get(`${this.api}/get-donation-sponsorship/${clubProgramID}`);
  }

  updateSponsorship(data) {
    return this.bs.post(`${this.api}/update-sponsorship`, data);
  }

  updateDonationAmount(clubProgramID: number, data) {
    return this.bs.post(`${this.api}/update-donation/${clubProgramID}`, data);
  }

  toggleSponsorship(on: boolean, clubProgramID: number) {
    return this.bs.put(`${this.api}/toggle-sponsorship/${clubProgramID}/${on ? 1 : 0}`);
  }

  updateSponsorshipOverview(clubProgramID: number, overview: string) {
    return this.bs.post(`${this.api}/update-sponsorship-overview/${clubProgramID}`, { overview });
  }

  toggleDonation(on: boolean, clubProgramID: number) {
    return this.bs.put(`${this.api}/toggle-donation/${clubProgramID}/${on ? 1 : 0}`);
  }

  deleteSponsorships(data: number[]) {
    return this.bs.post(`${this.api}/delete-sponsorships`, data);
  }

  getClubProgramFees(clubID: number) {
    return this.bs.get(`/api/ClubParent/program-fees-list-by-club/${clubID}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/club-program.service.ts